import EventEmitter from 'eventemitter3'

const GlobalEventService = {
  main: new EventEmitter(),
}
export default GlobalEventService
